import { render, staticRenderFns } from "./Client-account.vue?vue&type=template&id=3d96085d"
import script from "./Client-account.vue?vue&type=script&lang=js"
export * from "./Client-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports